import { render, staticRenderFns } from "./ucIndex.vue?vue&type=template&id=40ee7d50&scoped=true"
import script from "./ucIndex.vue?vue&type=script&lang=js"
export * from "./ucIndex.vue?vue&type=script&lang=js"
import style0 from "./ucIndex.vue?vue&type=style&index=0&id=40ee7d50&prod&lang=css"
import style1 from "./ucIndex.vue?vue&type=style&index=1&id=40ee7d50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee7d50",
  null
  
)

export default component.exports